<div class="rightComp">
  <div class="col-12 progressTracker" *ngIf="appealDetail && appealDetail.length > 0">
    <div class="trackerTitle mb-3" [ngClass]="isArabic ? 'rightAlign' : ''">
      <span *ngIf="!isArabic">Submitted Appeal : </span>
      <span *ngIf="isArabic">خطط العمل المقدمة:</span>
    </div>

    <table class="table table-striped table-bordered customTable">
      <thead>
        <tr>
          <th>Assessment Name</th>
          <th>Inspection</th>
          <th>Action</th>
          <th>Violation</th>
          <th>Appeal</th>
          <th class="midAlign">Overall Status</th>
          <th class="midAlign">#</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of appealDetail; let i = index">
          <td>
            {{ item.mde_AssessmentEntity?.name 
               || item.mde_assessmententity?.name 
               || item.mde_ActionPlan?.mde_AssessmentUnit?.name 
               || '-' }}
          </td>

          <td>
            {{ item.mde_InspectionPlan?.mde_name 
               || item.mde_inspection?.mde_name 
               || item.mde_ActionPlan?.mde_name 
               || '-' }}
          </td>

          <td>
            {{ item.mde_actionitem?.mde_name 
               || item.mde_actionitemName 
               || item.mde_name 
               || '-' }}
          </td>

          <td>
            {{ item.mde_Violation?.mde_name 
               || item.mde_violation?.mde_name 
               || item.mde_Violations?.mde_name 
               || '-' }}
          </td>

          <td>
            {{ item.mde_name || item.mde_appealid || '-' }}
          </td>

          <td class="midAlign">
           {{ item?.mde_appealstatus != null ? (
            item.mde_appealstatus === 755020000 ? 'Pending' :
            item.mde_appealstatus === 755020001 ? 'Submitted' :
            item.mde_appealstatus === 755020002 ? 'Approved' :
            item.mde_appealstatus === 755020003 ? 'Submitted' :
            item.mde_appealstatus === 755020004 ? 'Rejected' :
            item.mde_appealstatus === 755020005 ? 'Submitted' :
            item.mde_appealstatus === 755020006 ? 'Pending' :
            ''
        ) : ''}}
          </td>

          <td class="midAlign">
            <button
              (click)="goToDetail(item.mde_appealid)"
              class="showTxt"
            >
              View
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div *ngIf="!appealDetail || appealDetail.length === 0">
      <span *ngIf="!isArabic">No appeal history found.</span>
      <span *ngIf="isArabic">لا يوجد سجل للتنفيذ.</span>
    </div>
</div>
